import React from "react";
import {
  CardListItem,
  Button,
  Typography,
  CircularProgress,
} from "@ann/web-components";
import {
  FirstColumnWrapper,
  ColumnWrapper,
  RowWrapper,
  ActionWrapper,
  EmptyStateWrapper,
} from "../../Notes.styled";

const NotesContent = ({ notes = [], loading, error, onRetry, onDeleteNote, onOpenNote }) => {
  if (loading && notes.length === 0) {
    return (
      <EmptyStateWrapper>
        <CircularProgress size="small" />
      </EmptyStateWrapper>
    );
  }

  if (error) {
    return (
      <EmptyStateWrapper>
        <Typography category="body" weight="regular" size="medium" color="body">
          We couldn’t load notes.
        </Typography>
        <Button
          label="Try again"
          size="small"
          type="primary"
          onClick={onRetry}
        />
      </EmptyStateWrapper>
    );
  }

  if (!notes.length) {
    return (
      <EmptyStateWrapper>
        <Typography category="body" weight="regular" size="medium" color="body">
          No notes to show yet.
        </Typography>
      </EmptyStateWrapper>
    );
  }

  return (
    <CardListItem>
      {notes.map((note) => (
        <CardListItem.Row key={note.id}>
          <CardListItem.RowContent>
            <RowWrapper>
              <FirstColumnWrapper className="col-1">
                <Typography category="subtitle" weight="bold" size="small">
                  {note.title}
                </Typography>
              </FirstColumnWrapper>

              <ColumnWrapper className="col-2">
                <Typography category="subtitle" weight="bold" size="small">
                  Owner
                </Typography>
                <Typography
                  category="body"
                  weight="regular"
                  size="medium"
                  color="body"
                >
                  {note.owner}
                </Typography>
              </ColumnWrapper>

              <ColumnWrapper className="col-3">
                <Typography category="subtitle" weight="bold" size="small">
                  Category
                </Typography>
                <Typography
                  category="body"
                  weight="regular"
                  size="medium"
                  color="body"
                >
                  {note.category}
                </Typography>
              </ColumnWrapper>

              <ColumnWrapper className="col-4">
                <Typography category="subtitle" weight="bold" size="small">
                  Creation Date
                </Typography>
                <Typography
                  category="body"
                  weight="regular"
                  size="medium"
                  color="body"
                >
                  {note.creationDate}
                </Typography>
              </ColumnWrapper>
            </RowWrapper>
          </CardListItem.RowContent>

          <CardListItem.RowActions>
            <ActionWrapper>
              <Button
                size="small"
                type="secondary"
                icon="delete"
                pill={true}
                onClick={() => onDeleteNote?.(note)}
              />
              <Button
                size="small"
                type="primary"
                icon="arrowRight"
                pill={true}
                onClick={() => onOpenNote?.(note)}
              />
            </ActionWrapper>
          </CardListItem.RowActions>
        </CardListItem.Row>
      ))}
    </CardListItem>
  );
};

export default NotesContent;
